<template>
	<div class="row">
    <div class="col-sm-12 text-right">
      <b-dropdown id="dropdown-right" text="Action" variant="primary" class="m-2">
      <b-dropdown-item value="delete" @click="deleteSelectedFiles('delete')">Delete</b-dropdown-item>
    </b-dropdown>
    </div>
    <div class="col-md-12">
		<TableView v-if="showTable" :col="columns" ref="download_files" :getData="getData" :Options="{show_selection:true}"/>         
    </div>  
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
import  {mapActions} from 'vuex';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['row', 'selection','report_date','file_prefix'],
  data(){
  	return {
      showTable: true,
      columns: (() => {
        const cols = [
          { title: 'File Name', field: 'filename', thComp: 'FilterTh'},
          { title : 'Created Date', field: 'last_modified', tdComp: 'Timestamp'},
          { title: '', tdComp: 'controlReportOpt', visible: this.can_access('report','download') }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  methods: {
    ...mapActions('layout', ['changeBodyLoading']),
    async getData(query={}, filter={}) {
      this.changeBodyLoading(true);
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      this.columns.forEach(col => {
        if (query[col.nested||col.field]) {
          filter[col.nested||col.field] = query[col.nested||col.field];
        }else{
          delete filter[col.nested||col.field];
        }
      });
      let uri = 'get_report?file_prefix='+this.file_prefix+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri).then(res => {
        res.response.data.Pagination = false;
        this.changeBodyLoading(false);
        return res;
      });
    },
    deleteSelectedFiles(params) {
      if(params=='delete'){
        this.changeBodyLoading(true);
        this.$refs['download_files'].$children[0].selection.forEach((v,i)=>{
          this.call_axios('delete_report?filename='+v.filename, 'get', [], false).then((res)=> {
            if(this.$refs['download_files'].$children[0].selection.length == (i+1)) this.changeBodyLoading(false);
          })
        });
        this.showTable = false;
        this.$nextTick(() => {
          this.showTable = true;
        })
      }
    }
  }
}
</script>
<style>
</style>